<template>
    <!-- Yurt içi sürücü maaş süreci: Banka 2 önce → SGK Hakediş → Banka 1. İskelet mevcut Banka 2 sihirbazıyla aynıdır. -->
    <div class="row">
        <div v-if="!maximize" class="col-lg-3">
            <b-card>
                <app-timeline>
                    <app-timeline-item
                        v-for="(item,i) in shownItems" :key="i"
                        :time="item.time"
                        :title="item.title"
                        :subtitle="item.subtitle"
                        :icon="getIcon(i)"
                        :title-class="i == current ? `font-weight-bolder text-secondary`: null"
                        :variant="getVariant(i)" />
                </app-timeline>
            </b-card>
        </div>
        <div :class="!maximize ? 'col-lg-9' : 'col-12'">
            <b-card no-body class="p-1 mb-1">
                <div class="row align-items-center">
                    <div class="col-auto border-right">
                        <button class="btn btn-outline-dark btn-icon" v-b-tooltip.bottom.hover="!maximize ? 'Genişlet' : 'Daralt'" v-on:click="maximize = !maximize">
                            <feather-icon v-if="!maximize" icon="MaximizeIcon"></feather-icon>
                            <feather-icon v-else icon="MinimizeIcon"></feather-icon>
                        </button>
                    </div>
                    <div class="col-auto mb-1 mb-md-0">
                        <select class="form-control bg-img-none" style="min-width:120px" v-model="donem.month" :disabled="current > 0" aria-label="Ay">
                            <option v-for="m in months" :key="m.index" :value="m.index">{{m.name}}</option>
                        </select>
                    </div>
                    <div class="col-auto mb-1 mb-md-0">
                        <select class="form-control bg-img-none" style="min-width:96px" v-model="donem.year" :disabled="current > 0" aria-label="Yıl">
                            <option v-for="y in years" :key="y" :value="y">{{y}}</option>
                        </select>
                    </div>
                    <div class="col mb-1 mb-md-0" style="min-width:260px">
                        <v-select-list :options="employeeSalaryGroups" label="Value" v-model="employeeSalaryGroupId" :disabled="current > 0" placeholder="Maaş grubu seçin"></v-select-list>
                    </div>
                    <!-- Önizleme modu (İK, 22.10.2026): 1–3. adım kayıt yazmadan. Tasarım: claude.ai/artifact/PFrK6xiNuSzDvXaMrwH7Ca (A) -->
                    <div class="col-auto">
                        <div class="btn-group" role="group" aria-label="Çalışma modu" v-b-tooltip.bottom.hover="current > 0 ? 'Modu değiştirmek için 1. adıma dönün.' : null">
                            <button type="button" class="btn" :class="!preview ? 'btn-dark' : 'btn-outline-dark'" :aria-pressed="!preview" :disabled="current > 0" v-on:click="preview = false">Gerçek</button>
                            <button type="button" class="btn" :class="preview ? 'btn-warning' : 'btn-outline-warning'" :aria-pressed="preview" :disabled="current > 0" v-on:click="preview = true">Önizleme</button>
                        </div>
                    </div>
                </div>
            </b-card>

            <b-alert v-if="preview" show variant="warning" class="mb-1">
                <div class="alert-body d-flex align-items-center" style="color:#7a3d06">
                    <feather-icon icon="AlertCircleIcon" size="18" class="mr-50 flex-shrink-0"></feather-icon>
                    <span><strong>Önizleme modu:</strong> hesaplamalar gösterilir, sisteme hiçbir kayıt yazılmaz. Bu dönem mevcut Banka 2 sürecinde onaylı olsa da çalışır. Kesinleştir ve Ödeme adımları kapalıdır.</span>
                </div>
            </b-alert>

            <b-card v-if="!filter.EmployeeSalaryGroupId" class="mb-1">
                <div class="text-muted">Devam etmek için yurt içi sürücülerin maaş grubunu seçin.</div>
            </b-card>
            <template v-else>
                <dds-create-table v-if="current == 0" :donem="donem" :filter="filter" :preview-mode="preview" v-on:next="next(1)"></dds-create-table>
                <dds-upload-prims v-if="current == 1" :donem="donem" :filter="filter" :preview-mode="preview" :preview-file="previewFile" v-on:preview-file="f => previewFile = f" v-on:next="next(2)" v-on:back="next(0)"></dds-upload-prims>
                <dds-calculate v-if="current == 2" :donem="donem" :filter="filter" :preview-mode="preview" :preview-file="previewFile" v-on:next="next(3)" v-on:back="next(1)"></dds-calculate>
                <dds-finalize v-if="current == 3" :donem="donem" :filter="filter" v-on:next="next(4)" v-on:back="next(2)"></dds-finalize>
                <dds-payment v-if="current == 4" :donem="donem" :filter="filter" v-on:back="next(3)"></dds-payment>
            </template>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
import { BCard, BAlert, VBTooltip } from 'bootstrap-vue'
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import DdsCreateTable from './components/DdsCreateTable.vue'
import DdsUploadPrims from './components/DdsUploadPrims.vue'
import DdsCalculate from './components/DdsCalculate.vue'
import DdsPayment from './components/DdsPayment.vue'
import DdsFinalize from './components/DdsFinalize.vue'

export default {
    components: {
        AppTimeline,
        AppTimelineItem,
        BCard,
        BAlert,
        DdsCreateTable,
        DdsUploadPrims,
        DdsCalculate,
        DdsFinalize,
        DdsPayment
    },
    directives: {
        'b-tooltip': VBTooltip
    },
    data() {
        return {
            current: 0,
            preview: false,
            previewFile: null,
            donem: {
                year: moment().year(),
                month: moment().month() + 1
            },
            maximize: false,
            items: [
                { time: '1', title: 'Tablo Oluştur', subtitle: 'Banka 2 maaşı, puantaj (N, FM/HTM/GTM, AFOK) ve dönemin Banka 2 kesintileriyle tabloyu oluşturun; prim yükleme Excel’ini indirin.' },
                { time: '2', title: 'Primleri Yükle', subtitle: 'Doldurduğunuz prim Excel’ini yükleyin.' },
                { time: '3', title: 'Hesapla ve Düzenle', subtitle: 'SGK hakedişi ve bordro dağılımını kontrol edin; kırmızı satırları kalemle düzeltin.' },
                { time: '4', title: 'Kesinleştir', subtitle: 'Luca bordrosu yüklendikten sonra BES ve icra alınır, Banka 1 kesinleşir ve kilitlenir.' },
                { time: '5', title: 'Ödeme', subtitle: 'Maaş ve Harcırah banka dosyalarını oluşturun.' }
            ],
            years: [],
            months: [
                { index: 1, name: 'Ocak' }, { index: 2, name: 'Şubat' }, { index: 3, name: 'Mart' },
                { index: 4, name: 'Nisan' }, { index: 5, name: 'Mayıs' }, { index: 6, name: 'Haziran' },
                { index: 7, name: 'Temmuz' }, { index: 8, name: 'Ağustos' }, { index: 9, name: 'Eylül' },
                { index: 10, name: 'Ekim' }, { index: 11, name: 'Kasım' }, { index: 12, name: 'Aralık' }
            ],
            employeeSalaryGroups: [],
            employeeSalaryGroupId: null
        }
    },
    mounted() {
        this.configureYears()
        this.getEmployeeSalaryGroups()
    },
    methods: {
        getIcon(i) {
            if (this.current == i) return 'ArrowRightCircleIcon'
            if (this.current > i) return 'CheckCircleIcon'
            return 'AlertOctagonIcon'
        },
        getVariant(i) {
            if (this.preview && i > 2) return 'light'
            if (this.current == i) return 'secondary'
            if (this.current > i) return 'success'
            return 'dark'
        },
        next(i) {
            this.current = i
            window.scrollTo({ top: 0, behavior: 'smooth' })
        },
        getEmployeeSalaryGroups() {
            EmployeeOperationsApi.SalaryGroup.List().then(res => {
                this.employeeSalaryGroups = res.data
            })
        },
        configureYears() {
            const years = []
            const last = Number(moment().add(1, 'year').format('YYYY'))
            for (let y = last; y >= 2024; y--) years.push(y)
            this.years = years
        }
    },
    watch: {
        // Mod değişince önizleme dosyası sıfırlanır (gerçek ve önizleme verisi karışmasın).
        preview() {
            this.previewFile = null
        }
    },
    computed: {
        shownItems() {
            if (!this.preview) return this.items
            return this.items.map((item, i) => (i > 2 ? { ...item, subtitle: 'Önizlemede kapalı.' } : item))
        },
        filter() {
            return {
                EmployeeSalaryGroupId: this.employeeSalaryGroupId?.Key || null,
                Month: this.donem.month,
                Year: this.donem.year
            }
        }
    }
}
</script>
